import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './services/apps/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/home/home.routes').then((m) => m.HomeRoutes),
        canActivate: [AuthGuard],
      },
      {
        path: 'gestao',
        loadChildren: () =>
          import('./pages/modules/management/management.routes').then(
            (m) => m.ManagementRoutes,
          ),
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'relatorios',
      //   loadChildren: () =>
      //     import('./pages/modules/relatorios/reports.routes').then(
      //       (m) => m.RelatoriosRoutes,
      //     ),
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'configuracoes',
        loadChildren: () =>
          import('./pages/modules/settings/settings.routes').then(
            (m) => m.ConfiguracoesRoutes,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'plataforma',
        loadChildren: () =>
          import('./pages/platform/platform.routes').then(
            (m) => m.PlatformRoutes,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'moderacao',
        loadChildren: () =>
          import('./pages/modules/moderation/moderation.routes').then(
            (m) => m.ModerationRoutes,
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
